// extracted by mini-css-extract-plugin
module.exports = {"defaultLogoContainer":"index_defaultLogoContainer__rP1Rz","logo":"index_logo__JjH_o","largeLogoContainer":"index_largeLogoContainer__I0s8I","heartbeat":"index_heartbeat__sFctG"};